import request from '@/middleware/request'

const getRole = () => {
  return request({
    url: '/roles',
    method: 'get'
  })
}

const createRole = data => {
  return request({
    url: '/roles',
    method: 'post',
    data
  })
}

const updateRole = (id, data) => {
  return request({
    url: `/roles/${id}`,
    method: 'patch',
    data
  })
}

const deleteRole = id => {
  return request({
    url: `/roles/${id}`,
    method: 'delete'
  })
}

export default {
  getRole,
  createRole,
  updateRole,
  deleteRole
}
